//import { Input, TableColumnsType, Tooltip } from 'antd';
import { useSearchTableNew } from "hooks/otros/useSearchTableNew";
import { useSearchTableNoFilter } from "hooks/otros/useSearchTableNoFilter";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { TableRowSelection } from "antd/lib/table/interface";
import { VisorReporteOrdenCompra } from "./useGenerarOrden";
import { swalQuestion } from "config/methods";
import { Input, TableColumnsType, Tooltip } from "antd";

export default function UseOrdenCompraEdit(
  dataProductosOrden: VisorReporteOrdenCompra[],
  setdataProductosOrden: Function,
  getDataBodega: Function,
  setLoader: Function,
  OnChangeSelectionProveedor: Function,
  SumProveedorOrdenCompra: Function /*setselectkeyProveedor: Function onRowClick: (record: VisorReporte, index?: number) => React.HTMLAttributes<any> */
) {
  const vtRef = useRef<any>(null);
  const tableRef = useRef<HTMLDivElement>(null);
  const { getColumnSearchTableNoFilter } = useSearchTableNoFilter(dataProductosOrden, vtRef);
  const { getColumnSearchPropsNew: getColumnSearchPropsNewVisorReporte } = useSearchTableNew<VisorReporteOrdenCompra>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const handleSelectionChange = useCallback(
    async (newSelectedRowKeys: React.Key[]) => {
      setLoader(true);
      const currentKey = newSelectedRowKeys[0];
      console.log(newSelectedRowKeys);
      /*    if (selectedRowKeys?.[0] === currentKey) {
            setSelectedRowKeys([]);
          } else { */
      setSelectedRowKeys([currentKey]);

      try {
        const res = dataProductosOrden.filter((item) => item.key === currentKey);
        getDataBodega(res[0].Cod_Producto);
        OnChangeSelectionProveedor([res[0].Cod_Proveedor]);
        //setselectkeyProveedor([res[0].Cod_Proveedor])
        //console.log([res[0].Cod_Proveedor], 'proveedor')
      } catch (error) {
        // console.error("Error al obtener datos:", error);
      } finally {
        // setLoader(false);
      }
      //}
    },
    [dataProductosOrden, setLoader, getDataBodega, OnChangeSelectionProveedor]
  );

  const onRowClick = useCallback(
    (record: VisorReporteOrdenCompra) => {
      return {
        onClick: () => {
          const newSelectedRowKeys = [record.key];
          handleSelectionChange(newSelectedRowKeys);
        },
      };
    },
    [handleSelectionChange]
  );

  const rowSelection: TableRowSelection<VisorReporteOrdenCompra> = useMemo(
    () => ({
      selectedRowKeys,
      columnWidth: 0,
      onChange: handleSelectionChange,
      type: "radio",
    }),
    [selectedRowKeys, handleSelectionChange]
  );

  const OnChangePedirMia = (e: any, key: any) => {
    let newValue = e.target.value;
    const updatedData = dataProductosOrden.map((item) => {
      if (item.key === key) {
        if (/^[0-9]{0,10}$/.test(newValue)) {
          return { ...item, Pedir_Mia: newValue };
        }
      }
      return item;
    });
    setdataProductosOrden(updatedData);
    SumProveedorOrdenCompra(updatedData);
    //console.log(updatedData)
  };

  const OnChangeBoniMia = (e: any, key: any) => {
    let newValue = e.target.value;
    const updatedData = dataProductosOrden.map((item) => {
      if (item.key === key) {
        if (/^[0-9]{0,10}$/.test(newValue)) {
          return { ...item, Boni_Mia: newValue };
        }
      }
      return item;
    });
    setdataProductosOrden(updatedData);
    //console.log(updatedData)
  };

  const OnChangeBoniSG = (e: any, key: any) => {
    let newValue = e.target.value;
    const updatedData = dataProductosOrden.map((item) => {
      if (item.key === key) {
        if (/^[0-9]{0,10}$/.test(newValue)) {
          return { ...item, Boni_Sg: newValue };
        }
      }
      return item;
    });
    setdataProductosOrden(updatedData);
    //console.log(updatedData)
  };

  const OnChangePedirSg = (e: any, key: any) => {
    let newValue = e.target.value;
    const updatedData = dataProductosOrden.map((item) => {
      if (item.key === key) {
        if (/^[0-9]{0,10}$/.test(newValue)) {
          return { ...item, Pedir_Sg: newValue };
        }
      }
      return item;
    });
    setdataProductosOrden(updatedData);
    SumProveedorOrdenCompra(updatedData);

    //console.log(updatedData)
  };

  const duplicateRow = (record: VisorReporteOrdenCompra) => {
    const index = dataProductosOrden.findIndex((item) => item.key === record.key);
    const newKey = (Math.random() * 100000).toFixed(0);
    console.log(newKey); // key única
    const duplicated = { ...record, key: newKey, Pedir_Mia: 0, Pedir_Sg:0, Boni_Mia:0, Boni_Sg:0 };

    const newData = [...dataProductosOrden];
    newData.splice(index + 1, 0, duplicated); // insertar justo debajo
    getDataBodega(record.Cod_Producto);
    setdataProductosOrden(newData);
  };

  const Delete = (record: VisorReporteOrdenCompra) => {
    try {
      swalQuestion({
        text: `¿Esta seguro de eliminar el producto ${record.Descripcion} de la orden de Compra?`,
        icon: "warning",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const newdata = dataProductosOrden.filter((item) => item.key !== record.key);
          console.log(newdata, "prueba");
          setdataProductosOrden(newdata);
          /* const res = await fetch(
                    `${url}fapifsg-pr/sistemas/deleteTareas`,
                    optionsPost({cod_tarea: key.key})
                  )
                  if (res.status===200){
                    swalSuccess({text:"Tarea eliminada con éxito"})
                    getTareas()
                  } */
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const columns_orden: TableColumnsType<VisorReporteOrdenCompra> = [
    {
      title: "Descripción (" + dataProductosOrden.length + ")",
      className: "letraPequenaVisor",
      dataIndex: "Descripcion",
      key: "Descripcion",
      width: "200px",
      fixed: "left",
      ellipsis: true,
      ...getColumnSearchTableNoFilter("Descripcion"),
    },
    {
      title: "LAB",
      dataIndex: "LAB",
      className: "letraPequenaVisor",
      key: "LAB",
      fixed: "left",
      width: "40px",
      ...getColumnSearchPropsNewVisorReporte("LAB"),
    },
    {
      title: "Proveedor",
      className: "letraPequenaVisor",
      dataIndex: "Proveedor",
      key: "Proveedor",
      width: "100px",
      fixed: "left",
      ellipsis: true,
      ...getColumnSearchTableNoFilter("Proveedor"),
    },
    {
      title: "PVP",
      dataIndex: "PVP",
      key: "PVP",
      width: "37px",
      sorter: (a, b) => a.PVP - b.PVP,
      align: "right",
    },
    {
      title: "Costo",
      dataIndex: "Costo",
      key: "Costo",
      width: "40px",
      sorter: (a, b) => a.Costo - b.Costo,
      align: "right",
    },
    {
      title: "MrgB",
      dataIndex: "MrgB",
      key: "MrgB",
      width: "40px",
      sorter: (a, b) => a.MrgB - b.MrgB,
      align: "right",
    },
    {
      title: "PVPxMia",
      dataIndex: "PVPxMia",
      key: "PVPxMia",
      width: "55px",
      sorter: (a, b) => a.PVPxMia - b.PVPxMia,
      align: "right",
    },
    {
      title: "Descu_Mia",
      dataIndex: "Descu_Mia",
      key: "Descu_Mia",
      width: "60px",
      sorter: (a, b) => a.Descu_Mia - b.Descu_Mia,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Margen_Mia > record.Descu_Mia ? "transparent" : "#ffc2c2";
        return backgroundColor !== "transparent" ? (
          <Tooltip title='Bajo margen'>
            <div style={{ backgroundColor, padding: "0 8px" }}>{record.Descu_Mia}</div>
          </Tooltip>
        ) : (
          <div style={{ backgroundColor, padding: "0 8px" }}>{record.Descu_Mia}</div>
        );
      },
    },
    {
      title: "Marg_Mia",
      dataIndex: "Margen_Mia",
      key: "Margen_Mia",
      width: "56px",
      sorter: (a, b) => a.Margen_Mia - b.Margen_Mia,
      align: "right",
      render: (text, record, index) => {
        const isAlerta = record.Margen_Mia <= record.Descu_Mia;
        const backgroundColor = isAlerta ? "#ffc2c2" : "transparent";
        const content = <div style={{ backgroundColor, padding: "0 8px" }}>{record.Margen_Mia}</div>;
        return isAlerta ? <Tooltip title='Bajo margen'>{content}</Tooltip> : content;
      },
    },
    {
      title: "PVPxSG",
      dataIndex: "PVPxSG",
      key: "PVPxSG",
      width: "55px",
      sorter: (a, b) => a.PVPxSG - b.PVPxSG,
      align: "right",
    },
    {
      title: "Descu_SG",
      dataIndex: "Descu_SG",
      key: "Descu_SG",
      width: "60px",
      sorter: (a, b) => a.Descu_SG - b.Descu_SG,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Margen_SG > record.Descu_SG ? "transparent" : "#ffc2c2";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.Descu_SG}</div>;
      },
    },
    {
      title: "Marg_SG",
      dataIndex: "Margen_SG",
      key: "Margen_SG",
      width: "55px",
      sorter: (a, b) => a.Margen_SG - b.Margen_SG,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Margen_SG > record.Descu_SG ? "transparent" : "#ffc2c2";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.Margen_SG}</div>;
      },
    },
    {
      title: "Venta_Mia",
      dataIndex: "VENTA_MIA",
      key: "VENTA_MIA",
      width: "58px",
      sorter: (a, b) => a.VENTA_MIA - b.VENTA_MIA,
      align: "right",
      render: (text, record, index) => {
        const ratio = record.VENTA_MIA / record.MAX_Mia - 1;
        const backgroundColor = ratio > 0 ? "#fff176" : ratio < -0.5 ? "#f8bbd0" : "transparent";

        const tooltipText =
          backgroundColor === "#fff176" ? "Subastecimiento" : backgroundColor === "#f8bbd0" ? "SobreStock" : "";

        return backgroundColor !== "transparent" ? (
          <Tooltip title={tooltipText}>
            <div style={{ backgroundColor, padding: "0 8px" }}>{record.VENTA_MIA}</div>
          </Tooltip>
        ) : (
          <div style={{ backgroundColor, padding: "0 8px" }}>{record.VENTA_MIA}</div>
        );
      },
    },
    {
      title: "Venta_Sg",
      dataIndex: "VENTA_SG",
      key: "VENTA_SG",
      width: "58px",
      sorter: (a, b) => a.VENTA_SG - b.VENTA_SG,
      align: "right",
      render: (text, record, index) => {
        const ratio = record.VENTA_SG / record.MAX_SG - 1;
        const backgroundColor =
          ratio > 0
            ? "#fff176" // amarillo: sobreventa
            : ratio < -0.5
            ? "#f8bbd0" // rosa: muy por debajo del máximo
            : "transparent";

        const tooltipText =
          backgroundColor === "#fff176" ? "Subastecimiento" : backgroundColor === "#f8bbd0" ? "SobreStock" : "";

        return backgroundColor !== "transparent" ? (
          <Tooltip title={tooltipText}>
            <div style={{ backgroundColor, padding: "0 8px" }}>{record.VENTA_SG}</div>
          </Tooltip>
        ) : (
          <div style={{ backgroundColor, padding: "0 8px" }}>{record.VENTA_SG}</div>
        );
      },
    },
    {
      title: "Max_Mia",
      dataIndex: "MAX_Mia",
      key: "MAX_Mia",
      width: "55px",
      sorter: (a, b) => a.MAX_Mia - b.MAX_Mia,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Stock_Mia > record.MAX_Mia ? "#fff3cd" : "transparent";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.MAX_Mia}</div>;
      },
    },
    {
      title: "Stock_Mia",
      dataIndex: "Stock_Mia",
      key: "Stock_Mia",
      width: "60px",
      sorter: (a, b) => a.Stock_Mia - b.Stock_Mia,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Stock_Mia > record.MAX_Mia ? "#fff3cd" : "transparent";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.Stock_Mia}</div>;
      },
    },
    {
      title: "Max_SG",
      dataIndex: "MAX_SG",
      key: "MAX_SG",
      width: "57px",
      sorter: (a, b) => a.MAX_SG - b.MAX_SG,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Stock_Sg > record.MAX_SG ? "#fff3cd" : "transparent";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.MAX_SG}</div>;
      },
    },
    {
      title: "Stock_Sg",
      dataIndex: "Stock_Sg",
      key: "Stock_Sg",
      width: "55px",
      sorter: (a, b) => a.Stock_Sg - b.Stock_Sg,
      align: "right",
      render: (text, record, index) => {
        const backgroundColor = record.Stock_Sg > record.MAX_SG ? "#fff3cd" : "transparent";
        return <div style={{ backgroundColor, padding: "0 8px" }}>{record.Stock_Sg}</div>;
      },
    },
    {
      title: "PVF",
      dataIndex: "PVF",
      className: "letraPequenaVisor",
      key: "PVF",
      align: "right",
      width: "45px",
      sorter: (a, b) => Number(a.PVF) - Number(b.PVF),
      sortDirections: ["descend", "ascend"],
      render: (text) => {
        const num = Number(text);
        const truncated = Math.trunc(num * 100) / 100;
        return truncated.toFixed(2);
      },
    },
    {
      title: "M_Pack",
      dataIndex: "Master_Pack",
      className: "letraPequenaVisor",
      key: "Master_Pack",
      align: "right",
      width: "55px",
      sorter: (a, b) => Number(a.Master_Pack) - Number(b.Master_Pack),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Suge_M",
      dataIndex: "Suge_M",
      className: "letraPequenaVisor",
      key: "Suge_M",
      align: "right",
      width: "48px",
      sorter: (a, b) => Number(a.Suge_M) - Number(b.Suge_M),
      sortDirections: ["descend", "ascend"],
      /*           render:(Pedir_Mia, data)=>{
            //correcto
            let Sugerido_Mia:Number=0
            let porcentaje_mia: Number=0
            let sugerido_final: Number=0
            
            if(data.Pedir_Mia>0){
              Sugerido_Mia=data.Pedir_Mia
            }
             Sugerido_Mia=Number(Sugerido_Mia)+(Number(data.VENTA_MIA) -Number(data.S_B_Machala));
             porcentaje_mia=((Number(data.Master_Pack) * Number(Math.round((Number(Sugerido_Mia) / Number(data.Master_Pack))+0.1)))/Number(Sugerido_Mia))-1
          
             if(Number(porcentaje_mia)<0.25 && Number(porcentaje_mia)>0){
              sugerido_final=Number(data.Master_Pack) * Number(Math.round(Number((Number(Sugerido_Mia) / Number(data.Master_Pack))+0.1)))
             }else{
              sugerido_final=Sugerido_Mia
             }
            return Number(sugerido_final)<0?(0).toString():sugerido_final.toString()
          } */
    },
    {
      title: "Suge_P",
      dataIndex: "Suge_P",
      className: "letraPequenaVisor",
      key: "Suge_P",
      align: "right",
      width: "45px",
      sorter: (a, b) => Number(a.Suge_P) - Number(b.Suge_P),
      sortDirections: ["descend", "ascend"],
      /*  render:(Pedir_Sg, data)=>{
            let Sugerido_Sg:Number=0
            let porcentaje_Sg: Number=0
            let sugerido_final_Sg: Number=0
            
            if(data.Pedir_Sg>0){
              Sugerido_Sg=data.Pedir_Sg
            }
             Sugerido_Sg=Number(Sugerido_Sg)+(Number(data.VENTA_SG) -Number(data.S_B_Portoviejo));
             porcentaje_Sg=(Number(Sugerido_Sg)/(Number(data.Master_Pack) * Number((Number(Sugerido_Sg) / Number(data.Master_Pack)).toFixed(0))))-1
             //console.log( data.Descripcion, porcentaje_Sg)
             if(Number(porcentaje_Sg)<0.25 && Number(porcentaje_Sg)>0){
              sugerido_final_Sg=Number(data.Master_Pack) * Number((Number(Sugerido_Sg) / Number(data.Master_Pack)).toFixed(0))
             }else{
              sugerido_final_Sg=Sugerido_Sg
             }
            return Number(sugerido_final_Sg)<0?(0).toString():sugerido_final_Sg.toString()
          } */
    },
    {
      title: "Mach",
      dataIndex: "Pedir_Mia",
      className: "letraPequenaVisor",
      key: "Pedir_Mia",
      align: "right",
      width: "40px",
      sorter: (a, b) => Number(a.Pedir_Mia) - Number(b.Pedir_Mia),
      sortDirections: ["descend", "ascend"],
      render: (Pedir_Mia, data) => {
        /* et Sugerido_Mia:Number=0
            let porcentaje_mia: Number=0
            
            if(data.Pedir_Mia>0){
              Sugerido_Mia=data.Pedir_Mia
            }
             Sugerido_Mia=Number(Sugerido_Mia)+(Number(data.VENTA_MIA) -Number(data.S_B_Machala));
             porcentaje_mia=Number(Sugerido_Mia)/Number(data.Master_Pack) * Number((Number(Sugerido_Mia) / Number(data.Master_Pack)).toFixed(0)) */
        return (
          <>
            <Input
              maxLength={5}
              size='small'
              value={Number(Pedir_Mia) < 0 ? (0).toString() : Pedir_Mia.toString()}
              onFocus={() => {
                getDataBodega(data.Cod_Producto);
                handleSelectionChange([data.key]);
              }}
              onChange={(e) => {
                OnChangePedirMia(e, data.key);
              }}
              className='letraPequenaVisor'
              style={{ textAlign: "right", padding: 0 }}
            />
          </>
        );
      },
    },
    {
      title: "Boni_Mia",
      dataIndex: "Boni_Mia",
      className: "letraPequenaVisor",
      key: "Boni_Mia",
      align: "right",
      width: "53px",
      sorter: (a, b) => Number(a.Boni_Mia) - Number(b.Boni_Mia), //sorter: (a, b) => a.Descu.localeCompare(b.Descu.toString()),
      sortDirections: ["descend", "ascend"],
      render: (Boni_Mia, data) => {
        return (
          <>
            <Input
              size='small'
              maxLength={5}
              value={Boni_Mia}
              onFocus={() => {
                getDataBodega(data.Cod_Producto);
              }}
              onChange={(e) => {
                OnChangeBoniMia(e, data.key);
              }}
              className='letraPequenaVisor'
              style={{ textAlign: "right", padding: 0 }}
            />
          </>
        );
      },
    },
    {
      title: "Port",
      dataIndex: "Pedir_Sg",
      className: "letraPequenaVisor",
      key: "Pedir_Sg",
      align: "right",
      width: "40px",
      sorter: (a, b) => Number(a.Pedir_Sg) - Number(b.Pedir_Sg),
      sortDirections: ["descend", "ascend"],
      render: (Pedir_Sg, data) => {
        /*         let Sugerido_Sg:any=0
            if(data.Pedir_Sg>0){
              Sugerido_Sg=data.Pedir_Sg
            }
             Sugerido_Sg=Sugerido_Sg+(Number(data.VENTA_SG) -Number(data.S_B_Portoviejo)); */
        return (
          <>
            <Input
              size='small'
              maxLength={5}
              value={Number(Pedir_Sg) < 0 ? 0 : Pedir_Sg.toString()}
              onChange={(e) => OnChangePedirSg(e, data.key)}
              className='letraPequenaVisor'
              style={{ textAlign: "right", padding: 0 }}
            />
          </>
        );
      },
    },
    {
      title: "Boni_Sg",
      dataIndex: "Boni_Sg",
      className: "letraPequenaVisor",
      key: "Boni_Sg",
      align: "right",
      width: "52px",
      sorter: (a, b) => Number(a.Boni_Sg) - Number(b.Boni_Sg),
      sortDirections: ["descend", "ascend"],
      render: (Boni_Sg, data) => {
        return (
          <>
            <Input
              size='small'
              maxLength={5}
              value={Boni_Sg}
              onChange={(e) => OnChangeBoniSG(e, data.key)}
              className='letraPequenaVisor'
              style={{ textAlign: "right", padding: 0 }}
            />
          </>
        );
      },
    },
    {
      title: "Descu",
      dataIndex: "Descu",
      key: "Descu",
      width: "40px",
      align: "right",
      sorter: (a, b) => Number(a.Descu) - Number(b.Descu),
      sortDirections: ["descend", "ascend"],
      render: (text) => {
        const num = Number(text);
        const truncated = Math.trunc(num * 100) / 100;
        return truncated.toFixed(2);
      },
    },
    {
      title: "G",
      dataIndex: "G",
      key: "G",
      width: "30px",
      align: "center",
    },
    {
      title: "R",
      dataIndex: "R",
      key: "R",
      width: "30px",
      align: "center",
    },
    {
      title: "P",
      dataIndex: "P",
      key: "P",
      width: "30px",
      align: "center",
    },
    {
      title: "PMAC",
      dataIndex: "PMAC",
      key: "PMAC",
      width: "37px",
      align: "center",
    },
    {
      title: "C",
      dataIndex: "C",
      key: "C",
      width: "30px",
      align: "center",
    },
    {
      title: "Acción",
      className: "letraPequenaVisor",
      key: "C",
      width: "40px",
      align: "center",
      fixed: "right",
      render: (data) => {
        return (
          <>
            <Tooltip title='Duplicar' overlayStyle={{ fontSize: "10px" }} style={{ height: "12px" }}>
              <PlusOutlined
                onClick={() => {
                  duplicateRow(data);
                }}
              />{" "}
            </Tooltip>
            <Tooltip title='Eliminar' overlayStyle={{ fontSize: "10px" }} style={{ height: "12px" }}>
              <DeleteOutlined onClick={() => Delete(data)} />
            </Tooltip>
          </>
        );
      },
      // width: "40px",
    },
  ];

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (document.activeElement === tableRef.current || tableRef.current?.contains(document.activeElement)) {
        const currentIndex =
          selectedRowKeys.length > 0 ? dataProductosOrden.findIndex((item) => item.key === selectedRowKeys[0]) : -1;

        let newIndex = currentIndex;

        if (event.key === "ArrowDown") {
          event.preventDefault();
          newIndex = currentIndex < dataProductosOrden.length - 1 ? currentIndex + 1 : currentIndex;
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          newIndex = currentIndex > 0 ? currentIndex - 1 : currentIndex;
        }

        // Si el índice cambió, actualizar la selección
        if (newIndex !== currentIndex && newIndex >= 0) {
          const newSelectedRowKeys = [dataProductosOrden[newIndex].key];
          handleSelectionChange(newSelectedRowKeys);

          const rowElement = tableRef.current?.querySelector(`tr[data-row-key="${dataProductosOrden[newIndex].key}"]`);
          if (rowElement) {
            rowElement.scrollIntoView({ behavior: "auto", block: "nearest" });
          }
        }
      }
    };

    const tableElement = tableRef.current;
    if (tableElement) {
      tableElement.setAttribute("tabindex", "0");
      tableElement.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      if (tableElement) {
        tableElement.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [selectedRowKeys, dataProductosOrden, handleSelectionChange]);
  return {
    columns_orden,
    vtRef,
    tableRef,
    rowSelection,
    onRowClick,
  };
}
